import { InsuranceParameters } from '../types';

let today = new Date();

let tomorrow = new Date(today);
tomorrow.setDate(today.getDate() + 1);
tomorrow.toLocaleDateString();

let oneWeek = new Date(today);
oneWeek.setDate(today.getDate() + 8);
oneWeek.toLocaleDateString();

export const INSURANCE_INIT_PARAMS: InsuranceParameters = {
  modalsVisibility: {
    countries: false,
    dates: false,
    tourists: false,
  },
  selectedCountry: { name: {}, id: '' },
  selectedTourists: [],
  selectedDates: {
    startDate: '',
    endDate: '',
    key: 'selection',
  },
  selectedInsurance: {
    name: '',
    sum: 0,
    logo: '',
  },
};
